import { AosYandexCaptcha } from '../yandex_captcha';

const YANDEX_CAPTCHA_TYPES = ['yandex_hybrid', 'yandex_hard'];
const SMART_TOKEN_FIELD = 'smart-token';

BX.Vue.component('aos__initial-data', {
  data: function () {
    return {
      attemptConnection: 0,
      captcha: null,
      yandexCaptcha: null,
      smartToken: null,
      content: {
        desc: null,
        checkbox: null,
      },
      options: {
        errorTime: false,
        errorDelay: 5000,
        stepDirection: 'right',
        timer: {
          end: 180,
        },
      },
      obj: {
        aos: null,
        birthday: null,
        form: {
          phoneAction: null,
          checkbox: null,
          btn: null,
        },
        phone: {
          phone: null,
          code: null,
          codeConfirm: null,
        },
      },
      flags: {
        sendCode: false,
        captchaPending: false,
      },
      fieldSMS: null,
      formAgreements: null,
      popupId: {},
    };
  },
  methods: {
    addMaskedToPhone: function (input) {
      let vm = this;
      if (input.classList.contains('form__text-input__phone')) {
        $(input)
          .inputmask({
            mask: '+7 (999) 999-99-99',
            showMaskOnHover: false,
            showMaskOnFocus: true,
            oncleared: function () {
              vm.$parent.removeError(this);
            },
            onincomplete: function () {
              vm.checkEmptyPhone(this);
              vm.prepareRuPhoneCode(this);
              if (this.value !== '') {
                vm.$parent.appendMess(input, 'A_AOS_INITIAL_DATA_PHONE_INCORRECT', false);
              }
            },
            oncomplete: function () {
              vm.checkEmptyPhone(this);
              vm.$parent.removeError(this);
              vm.$parent.phone = vm.obj.phone.phone.value;
            },
            onBeforePaste: function onBeforePaste(pastedValue, opts) {
              pastedValue = pastedValue.replace(/\D/g, '');

              if (pastedValue.length === 11) {
                pastedValue = pastedValue.substr(1, pastedValue.length);
              }

              return pastedValue;
            },
          })
          .on('paste', function (e) {
            vm.checkEmptyPhone(input);
            if (e.target.value.indexOf('_') === -1) {
              vm.$parent.removeError(this);
            }
            vm.prepareRuPhoneCode(e.target);
            vm.formReadyCheck();
          });
        input.classList.add('__masked');
        vm.actionCopy(input);
        input.addEventListener('keyup', function (e) {
          vm.prepareRuPhoneCode(e.target);
          vm.formReadyCheck();
        });
      }
    },
    /**
     * Проверяет значение в поле даты после приминения datepicker
     * @param input
     * @returns {*|boolean}
     */
    checkDateValue: function (input) {
      let vm = this;
      var fError =
        (input.required && input.value.replace(/[\_\.]/g, '') === '') ||
        input.value.replace(/[\d\.]/g, '') !== '';
      if (
        !fError &&
        input.value !== '' &&
        input.value.indexOf('_') === -1 &&
        !BX.validateDate(input.value)
      )
        fError = true;
      if (!fError && input.value) {
        var curDate = new Date();
        var timeInputSplit = input.value.split('.');
        var timeInputValue = new Date(
          timeInputSplit[2],
          timeInputSplit[1] - 1,
          timeInputSplit[0],
        );
        var timeMin = new Date(
          curDate.getFullYear() - 100,
          curDate.getMonth(),
          curDate.getDate(),
        );
        var timeMax = new Date(
          curDate.getFullYear(),
          curDate.getMonth(),
          curDate.getDate(),
        );
        if (input.getAttribute('name')) {
          timeMax = new Date(
            curDate.getFullYear() - 18,
            curDate.getMonth(),
            curDate.getDate(),
          );
          if (
            vm.dateCompare(timeInputValue, timeMax) === 1 ||
            vm.dateCompare(timeInputValue, timeMin) === -1
          ) {
            fError = true;
          }
        }
      }

      return !fError;
    },
    dateCompare: function (a, b) {
      let vm = this;
      //  -1 : if a < b
      //   0 : if a = b
      //   1 : if a > b
      // NaN : if a or b is an illegal date
      return isFinite((a = vm.dateConvert(a).valueOf())) &&
        isFinite((b = vm.dateConvert(b).valueOf()))
        ? (a > b) - (a < b)
        : NaN;
    },
    dateConvert: function (d) {
      return d.constructor === Date
        ? d
        : d.constructor === Array
          ? new Date(d[0], d[1], d[2])
          : d.constructor === Number
            ? new Date(d)
            : d.constructor === String
              ? new Date(d)
              : typeof d === 'object'
                ? new Date(d.year, d.month, d.date)
                : NaN;
    },
    addTipError: function (inp, tip) {
      let vm = this;

      if (!inp) {
        return false;
      }

      var dataTip = tip ? tip : inp.value ? 'data-tip-incorrect' : 'data-tip-empty';
      dataTip = inp.closest('[' + dataTip + ']')?.getAttribute(dataTip);
      if (dataTip) {
        vm.$parent.appendMess(inp, dataTip, false);
      } else {
        vm.$parent.appendMess(inp, 'TIP_ERROR_EM_FIELD', false);
      }
    },
    addMaskedToBirthday: function (input) {
      let vm = this;
      if (input.classList.contains('form__text-input__birthday')) {
        $(input)
          .inputmask({
            alias: 'datetime',
            inputFormat: 'dd.mm.yyyy',
            prefillYear: false,
            placeholder: vm.$parent.msg('A_AOS_INITIAL_DATA_FIELD_BIRTHDAY_PLACEHOLDER'),
            showMaskOnHover: false,
            showMaskOnFocus: true,
            oncleared: function () {
              vm.checkEmptyPhone(this);
              vm.$parent.removeError(this);
            },
            onincomplete: function () {
              vm.checkEmptyPhone(this);
              if (this.value !== '') {
                vm.$parent.appendMess(
                  input,
                  'A_AOS_INITIAL_DATA_BIRTHDAY_INCORRECT',
                  false,
                );
              }
            },
            oncomplete: function () {
              atonAOS.stepComponent.checkEmptyField(this);
              if (vm.checkDateValue(this)) {
                vm.$parent.removeError(this);
              } else {
                vm.addTipError(this);
              }
              vm.checkEmptyPhone(this);
              vm.$parent.birthday = this.value;
            },
            onBeforePaste: function onBeforePaste(pastedValue, opts) {
              pastedValue = pastedValue.replace(/\D/g, '');

              if (pastedValue.length === 8) {
                pastedValue = pastedValue.substr(1, pastedValue.length);
              }

              return pastedValue;
            },
            onKeyValidation: (key, result, opts) => {
              if (!result && !vm.checkDateValue(input)) {
                vm.$parent.appendMess(
                  input,
                  'A_AOS_INITIAL_DATA_BIRTHDAY_INCORRECT',
                  false,
                );
              } else {
                vm.$parent.removeError(input);
              }
            },
          })
          .on('paste', function (e) {
            vm.checkEmptyPhone(input);
            if (e.target.value.indexOf('_') === -1) {
              vm.$parent.removeError(this);
            }
            vm.formReadyCheck();
          });

        input.classList.add('__masked');
        vm.actionCopy(input);

        input.addEventListener('keyup', function (e) {
          vm.formReadyCheck();
        });
      }
    },
    captchaUpdateData: (vm, data) => {
      if (vm.captcha !== null) data = vm.captcha.updateData(data);
      return vm.withSmartToken(data);
    },
    /**
     * Создаёт YandexSmartCaptcha, если этот тип капчи выбран в настройках сервиса.
     * Видимый виджет рендерится сразу, невидимый - при первой отправке формы
     */
    initYandexCaptcha: function () {
      let vm = this;
      let captcha = vm.$parent.options.captcha;

      if (!captcha || !YANDEX_CAPTCHA_TYPES.includes(captcha.type)) {
        return;
      }

      vm.yandexCaptcha = new AosYandexCaptcha(vm.$refs.yandexCaptcha, captcha.params);
      if (!vm.yandexCaptcha.isInvisible()) {
        vm.yandexCaptcha.render().catch(() => {});
      }
    },
    /**
     * Получает токен YandexSmartCaptcha перед запросом на отправку СМС
     * @returns {Promise<void>}
     */
    requestSmartToken: function () {
      let vm = this;

      vm.flags.captchaPending = true;

      return vm.yandexCaptcha
        .getToken()
        .then((token) => {
          vm.smartToken = token;
        })
        .finally(() => {
          vm.flags.captchaPending = false;
        });
    },
    withSmartToken: function (data) {
      let vm = this;
      if (vm.yandexCaptcha === null) return data;
      return { ...data, [SMART_TOKEN_FIELD]: vm.smartToken || '' };
    },
    showCaptchaError: function () {
      let vm = this;
      vm.$parent.messageError(vm.$parent.msg('A_AOS_INITIAL_DATA_CAPTCHA_ERROR'));
    },
    /**
     * Токен одноразовый: после ответа бэка сбрасываем капчу.
     * Если бэк прислал новые параметры (усложнённая капча) - пересоздаём виджет
     * @param requestData
     */
    refreshYandexCaptcha: function (requestData) {
      let vm = this;

      if (vm.yandexCaptcha === null || requestData?.status === 'waiting') {
        return;
      }

      vm.smartToken = null;

      let params = requestData?.data?.captchaParams;
      if (params && params.KEY_CLIENT) {
        vm.$parent.options.captcha.params = params;
        vm.yandexCaptcha.restart(params).catch(() => {});
      } else {
        vm.yandexCaptcha.reset();
      }
    },
    prepareRuPhoneCode: function (input) {
      // No-op. Ранее конвертировала префикс "+7 (8…"/"+7 (7…" → "+7", считая ведущую
      // 8/7 транковым/страновым префиксом. Но это ломало легитимные коды городов,
      // начинающиеся на 8/7 (СПб 812, 841 и т.п.): маска пересобирала значение и теряла
      // последнюю цифру. Транковый/страновой префикс уже корректно снимает onBeforePaste
      // при вставке (substr(1) для 11 цифр), поэтому доп. обработка не нужна и вредна.
    },
    actionCopy: function (input) {
      // Вставку форматирует сам Inputmask (onBeforePaste: нормализует и обрезает
      // ведущую 8/7). Раньше здесь значение перезаписывалось сырым текстом из буфера,
      // из-за чего маска повторно разбирала 11 цифр и теряла последнюю. Теперь только
      // поддерживаем класс __filled по итоговому (уже отформатированному) значению поля,
      // не трогая его. setTimeout — чтобы прочитать value после обработки вставки.
      input.addEventListener('paste', function () {
        setTimeout(function () {
          if (input.value !== '') input.classList.add('__filled');
        }, 0);
      });
    },
    /**
     * Возвращает статус заполненности номера телефона
     * @param input
     * @returns {string|boolean}
     */
    getStatusEntered: function (input) {
      let dMask = input.getAttribute('data-mask');
      if (!dMask) {
        return false;
      }

      dMask = dMask.replace(/[^\_\d]/g, '');
      let pValue = input.value.replace(/[^\d]/g, '');
      if (pValue.length === 0) {
        return 'clear';
      } else if (pValue.length < dMask.length) {
        return 'incomplete';
      } else if (pValue.length === dMask.length) {
        return 'complete';
      }
    },
    /**
     * Добавление маски для поля с вводом номера телефона
     */
    maskedPhone: function () {
      let vm = this;
      let tempInt = setInterval(function () {
        let map = BX.find('.form__text-input__phone');
        if (map) {
          clearInterval(tempInt);
          for (let i in map) {
            vm.addMaskedToPhone(map[i]);
            vm.checkEmptyPhone(map[i]);
          }
        }
      }, 10);
    },
    /**
     * Добавление маски для поля с вводом даты рождения
     */
    maskedBirthday: function () {
      let vm = this;
      let tempInt = setInterval(function () {
        let map = BX.find('.form__text-input__birthday');
        if (map) {
          clearInterval(tempInt);
          for (let i in map) {
            vm.addMaskedToBirthday(map[i]);
          }
        }
      }, 10);
    },
    /**
     * Проверяет наличие цифр в номере телефона
     * @param input
     */
    checkEmptyPhone: function (input) {
      let vm = this;
      vm.$parent.checkEmptyField(input, input.value.replace(/[^\d]/g, ''));
    },
    getField: function (obj) {
      return obj.classList.contains('form__field') ||
        obj.classList.contains('form__chbox')
        ? obj
        : obj.type === 'checkbox'
          ? obj.closest('.form__chbox')
          : obj.closest('.form__field');
    },
    formReadyCheck: function () {
      let vm = this;

      let inputPhoneIsComplete = $('.form__text-input__phone');
      if (inputPhoneIsComplete) {
        inputPhoneIsComplete = inputPhoneIsComplete.inputmask('isComplete');
      }

      let inputBirthday = vm.$parent.aos.querySelector('.form__text-input__birthday');
      //mobile id not required
      let mobileIdCheckboxChecked = true;

      if (
        inputPhoneIsComplete &&
        mobileIdCheckboxChecked &&
        vm.checkDateValue(inputBirthday)
      ) {
        vm.obj.form.btn.removeAttribute('disabled');
        return true;
      } else {
        vm.obj.form.btn.setAttribute('disabled', true);
        return false;
      }
    },
    checkboxEventClick: function () {
      let vm = this;
      vm.formReadyCheck();
      vm.hideMobileIdSopd();
    },
    hideMobileIdSopd: function () {
      let vm = this;
      let sopd = vm.$parent.aos?.querySelector('.form__sopd');
      let sopdMobileId = sopd.querySelector('#sopd_mobile_id');
      let isChecked = vm.$parent.aos?.querySelector("[name='use_mobile_id']")?.checked;

      if (sopdMobileId) sopdMobileId.style.display = isChecked ? 'block' : 'none';
    },
    visiblePhoneTip: function (name) {
      let vm = this;
      let tipPhone = vm.obj.aos.querySelector('.form__tip__phone');
      let obj = null;

      if (name) {
        obj = tipPhone.querySelector('.form__tip__' + name);
      }

      let tips = BX.aBase.find('.' + tipPhone.getAttribute('class') + '> div', tipPhone);
      for (let i in tips) {
        let tip = tips[i];
        tip.style.display = 'none';
      }

      if (obj) {
        obj.style.display = 'block';
      }
    },
    initAFieldSMS: function () {
      let vm = this;
      vm.fieldSMS = new AFieldSms({
        actions: {
          resend: function () {
            vm.resendCode();
          },
          send: function (value) {
            vm.validatePhoneCodeAction(true, '', value);
          },
        },
        template: 'aos',
        values: {
          autoInitial: true,
          autoSend: true,
          phone: vm.obj.phone.phone.value,
          position: 'left',
          showTimer: true,
          disclaimer: vm.$parent.msg('A_AOS_INITIAL_DATA_FIELD_SMS_DISCLAIMER'),
          elementType: 'label',
        },
      });
      vm.fieldSMS.create(
        vm.obj.phone.codeConfirmContainer,
        vm.options.timer.end,
        function () {
          vm.$parent.btnLoader(vm.obj.form.btn, false);
          vm.obj.phone.codeConfirm.style.display = 'block';
          vm.obj.phone.confirm.style.display = 'none';
          vm.obj.birthday.parentNode.style.display = 'none';
          vm.obj.phone.phone.classList.add('-disabled');
          vm.obj.form.phoneAction.style.display = 'block';
          vm.$refs.phoneField.classList.remove('__success');
          vm.visiblePhoneTip('phone-code-send');
        },
      );
      vm.$parent.removeMessageError();
    },
    validatePhoneAction: function (isWaitingStart, id) {
      let vm = this;

      if (isWaitingStart) {
        vm.$parent.btnLoader(vm.obj.form.btn, true);
        vm.attemptConnection = vm.$parent.options.timeoutConnection;
      } else {
        if (vm.attemptConnection > 0) {
          --vm.attemptConnection;
        } else {
          vm.attemptConnection = 0;
        }
      }

      let form = vm.obj.aos.querySelector('.ocf__step form');
      let formData = new FormData(form);

      vm.$parent.clientData.birthDate = formData.get('birthday');

      BX.ajax
        .runComponentAction('aton:aos', 'validatePhone', {
          url: location.pathname,
          method: 'post',
          mode: 'class',
          data: {
            data: vm.captchaUpdateData(vm, {
              is_waiting: vm.attemptConnection > 0 ? 'Y' : 'N',
              id: id ? id : '',
              phone: formData.get('phone'),
              birthday: formData.get('birthday'),
              use_mobile_id: formData.get('use_mobile_id') ? 'Y' : 'N',
              process_id: '',
              agreements: formData.getAll('form_checkbox_AGREE_LIST[]'),
              url: location.href,
            }),
          },
        })
        .then(function (request) {
          vm.refreshYandexCaptcha(request.data);
          if (request.status === 'success') {
            let requestData = request.data;
            if (requestData.ymGoalCode && typeof ym !== 'undefined') {
              ym(28725931, 'reachGoal', requestData.ymGoalCode);
            }
            if (requestData.status === 'success') {
              if (vm.captcha !== null) {
                BX.aBase.remove(vm.captcha.captcha);
                vm.captcha = null;
              }
              vm.initAFieldSMS();
              vm.$parent.title = vm.$parent.msg(
                'A_AOS_INITIAL_DATA_PHONE_CONFIRMATION_TITLE',
              );
            } else if (requestData.status === 'waiting') {
              setTimeout(function () {
                vm.validatePhoneAction(false, requestData.data.id);
              }, 1000);
            } else if (requestData.status === 'error') {
              if (requestData?.isProcessVersionDiff) {
                vm.$parent.step = 'BAN';
                if (requestData?.title) vm.$parent.banTitle = requestData?.title;
                if (requestData?.message) vm.$parent.banText = requestData?.message;
              }

              if (
                requestData.data.captcha &&
                requestData.data.captcha === 'y' &&
                vm.yandexCaptcha === null
              ) {
                vm.$parent.captchaInit(vm, () => {
                  let cInt = setInterval(() => {
                    if (vm.captcha.captcha) {
                      vm.captcha.input().value = '';
                      clearInterval(cInt);
                    }
                  }, 1);
                  if (!requestData.alert_hide || requestData.alert_hide !== 'y') {
                    vm.$parent.messageError(requestData.message);
                  }
                  vm.$parent.btnLoader(vm.obj.form.btn, false);
                });
              } else {
                vm.$parent.messageError(requestData.message);
                vm.visiblePhoneTip('phone-error');
                vm.$parent.btnLoader(vm.obj.form.btn, false);
              }
            }
          } else {
            vm.$parent.messageError();
            vm.visiblePhoneTip('phone-error');
            vm.$parent.btnLoader(vm.obj.form.btn, false);
          }
        })
        .catch(function () {
          vm.refreshYandexCaptcha();
          vm.$parent.messageError();
          vm.visiblePhoneTip('phone-error');
          vm.$parent.btnLoader(vm.obj.form.btn, false);
        });
    },
    /**
     * Повторная отправка кода. Бэк проверяет токен YandexSmartCaptcha и здесь:
     * если получить его не удалось - возвращаем пользователя к вводу номера телефона
     */
    resendCode: function () {
      let vm = this;

      if (vm.yandexCaptcha === null) {
        vm.validatePhoneResendAction(true);
        return;
      }

      if (vm.flags.captchaPending) {
        return;
      }

      vm.requestSmartToken()
        .then(() => vm.validatePhoneResendAction(true))
        .catch(() => {
          vm.obj.aos.querySelector('.phone-action__edit')?.click();
          vm.showCaptchaError();
        });
    },
    validatePhoneResendAction: function (isWaitingStart, id) {
      let vm = this;
      let fieldSms = vm.obj.aos.querySelector('.form__field-sms');

      if (isWaitingStart) {
        vm.$parent.blurLoader(vm.$parent.aos, true);
        vm.attemptConnection = vm.$parent.options.timeoutConnection;
      } else {
        if (vm.attemptConnection > 0) {
          --vm.attemptConnection;
        } else {
          vm.attemptConnection = 0;
        }
      }

      BX.ajax
        .runComponentAction('aton:aos', 'validatePhoneResend', {
          url: location.pathname,
          method: 'post',
          mode: 'class',
          data: {
            data: vm.withSmartToken({
              is_waiting: vm.attemptConnection > 0 ? 'Y' : 'N',
              id: id ? id : '',
            }),
          },
        })
        .then(function (request) {
          let requestData = request.data;
          vm.refreshYandexCaptcha(requestData);
          vm.obj.phone.codeConfirm.classList.remove('-wait');
          if (requestData.status === 'success') {
            vm.fieldSMS.destroy();
            vm.fieldSMS = null;
            vm.obj.phone.codeConfirmContainer.innerHTML = '';
            vm.initAFieldSMS();
            vm.$parent.blurLoader(vm.$parent.aos, false);
          } else if (requestData.status === 'waiting') {
            setTimeout(() => {
              vm.validatePhoneResendAction(false, requestData.data.id);
            }, 1000);
          } else if (requestData.status === 'error') {
            let form = fieldSms.closest('.form');
            form.querySelector('.phone-action__edit').click();
            if (vm.yandexCaptcha !== null) {
              vm.$parent.messageError(requestData.message);
              vm.$parent.blurLoader(vm.$parent.aos, false);
              return;
            }
            let tempInitCaptcha = setInterval(() => {
              let phoneConfirm = form.querySelector('.phone-confirm');
              let disclaimer = form.querySelector('.form__field-disclaimer');
              if (
                disclaimer === null &&
                phoneConfirm !== null &&
                phoneConfirm.clientHeight > 0
              ) {
                clearInterval(tempInitCaptcha);
                vm.$parent.captchaInit(vm, () => {
                  vm.$parent.blurLoader(vm.$parent.aos, false);
                });
              }
            }, 10);
          } else {
            vm.$parent.messageError(requestData.message);
            vm.visiblePhoneTip('phone-error');
            vm.$parent.blurLoader(vm.$parent.aos, false);
          }
        })
        .catch(function () {
          vm.refreshYandexCaptcha();
          vm.$parent.messageError();
          vm.visiblePhoneTip('phone-error');
          vm.$parent.blurLoader(vm.$parent.aos, false);
        });
    },
    validatePhoneCodeAction: function (isWaitingStart, id, code) {
      let vm = this;
      let fieldSms = vm.obj.aos.querySelector('.form__field-sms');

      if (isWaitingStart && vm.flags.sendCode) {
        return false;
      }

      if (isWaitingStart) {
        vm.flags.sendCode = true;
        vm.$parent.blurLoader(vm.$parent.aos, true);
        vm.attemptConnection = vm.$parent.options.timeoutConnection;

        if (BX.type.isNil(code)) {
          let confirmationCode = vm.obj.aos.querySelector('[name="confirmation_code"]');
          if (!confirmationCode) return false;
          code = confirmationCode.value;
        }

        vm.$parent.blurLoader(vm.$parent.aos, true);
      } else {
        if (vm.attemptConnection > 0) {
          --vm.attemptConnection;
        } else {
          vm.attemptConnection = 0;
        }
      }

      BX.ajax
        .runComponentAction('aton:aos', 'validatePhoneCode', {
          url: location.pathname,
          method: 'post',
          mode: 'class',
          data: {
            isWaiting: vm.attemptConnection > 0 ? 'Y' : 'N',
            id: id ? id : '',
            code: code,
            isSubscribe: null,
            phone: vm.obj.phone.phone.value,
          },
        })
        .then(function (request) {
          vm.flags.sendCode = false;
          if (request.status === 'success') {
            let requestData = request.data;
            if (requestData.ymGoalCode && typeof ym !== 'undefined') {
              ym(28725931, 'reachGoal', requestData.ymGoalCode);
            }
            if (requestData.status === 'success') {
              document.dispatchEvent(new CustomEvent('AtonAosSuccessValidatePhoneCode'));
              vm.$parent.timeoutAnimate(function () {
                vm.$parent.blurLoader(vm.$parent.aos, false);
                if ('emailValidated' in requestData) {
                  vm.$parent.isEmailValidate = requestData.emailValidated;
                }

                if (requestData.data && Object.keys(requestData.data).length > 0) {
                  if (requestData.data.clientData) {
                    const birthdayData = vm.$parent.clientData.birthDate;
                    vm.$parent.clientData = {
                      ...requestData.data.clientData,
                      birthDate: birthdayData,
                    };
                  }

                  switch (requestData.data.activeTaskName) {
                    case 'ACCOUNT_OPENED':
                      vm.$parent.step = 'FINAL';
                      //location.href = '/aos/final/';
                      return false;
                    case 'QUESTIONNAIRE':
                      vm.$parent.isEmailValidate = true;
                      break;
                    case 'PD_CHECK_EXTENDED':
                    case 'ACCOUNT_CREATION':
                      vm.$parent.step = 'PROCESSING';
                      vm.$parent.scrollToElement('#aos', 0);
                      return false;
                    case 'DOC_GENNSIGN':
                      vm.$parent.step = 'DOCS_FOR_SIGN';
                      vm.$parent.scrollToElement('#aos', 0);
                      return false;
                    case 'SUS_ACTIVITY_STATE':
                      vm.$parent.step = 'BAN';
                      vm.$parent.scrollToElement('#aos', 0);
                      return false;
                  }
                }

                vm.$parent.step = 'KID';
                if (
                  requestData.data.activeTaskName === 'QUESTIONNAIRE' &&
                  requestData.data.pdCheckDenyReason
                ) {
                  vm.$parent.stepData.pdCheckError = true;
                }
              }, 1000);
            } else if (requestData.status === 'waiting') {
              setTimeout(function () {
                vm.validatePhoneCodeAction(false, requestData.data.id, code);
              }, 1000);
            } else if (requestData.status === 'error') {
              if (requestData.message.includes('#LINK_RESEND#')) {
                vm.$parent.messageError(
                  requestData.message.replace(
                    '#LINK_RESEND#',
                    vm.$parent.msg('A_AOS_INITIAL_DATA_SMS_RESEND'),
                  ),
                );
              } else {
                vm.$parent.messageError(requestData.message);
              }

              vm.fieldSMS.base.resetValues(fieldSms, true);
              fieldSms.classList.add('form__field_error');

              fieldSms.addEventListener(
                'click',
                () => {
                  fieldSms.classList.remove('form__field_error');
                },
                { once: true },
              );

              if (requestData.data.hidePhoneCode === 'Y') {
                if (requestData?.errorCode === 160) {
                  vm.obj.phone.codeConfirm.classList.add('-wait');
                  fieldSms.style.display = 'none';
                } else {
                  let form = fieldSms.closest('.form');
                  form?.querySelector('.phone-action__edit')?.click();
                }
              }
              vm.$parent.addError(fieldSms);
              vm.$parent.blurLoader(vm.$parent.aos, false);
            }
          } else {
            vm.$parent.messageError(
              vm.$parent.msg('A_AOS_INITIAL_DATA_DEFAULT_PHONE_CODE'),
            );
            vm.$parent.blurLoader(vm.$parent.aos, false);
          }
        })
        .catch(function () {
          vm.flags.sendCode = false;
          vm.$parent.messageError(
            vm.$parent.msg('A_AOS_INITIAL_DATA_DEFAULT_PHONE_CODE'),
          );
          vm.$parent.blurLoader(vm.$parent.aos, false);
        });
    },
    formSend: function () {
      let vm = this;

      if (!vm.formReadyCheck() || vm.obj.phone.confirm.classList.contains('aos-hidden')) {
        return false;
      }

      vm.acceptCookies();

      if (vm.yandexCaptcha === null) {
        vm.validatePhoneAction(true);
        return;
      }

      if (vm.flags.captchaPending) {
        return false;
      }

      vm.$parent.btnLoader(vm.obj.form.btn, true);
      vm.requestSmartToken()
        .then(() => vm.validatePhoneAction(true))
        .catch(() => {
          vm.$parent.btnLoader(vm.obj.form.btn, false);
          vm.showCaptchaError();
        });
    },
    initFormAgreements: function () {
      let vm = this;
      if (BX.type.isNil(vm.formAgreements)) {
        let intervalAgreements = setInterval(() => {
          if (typeof AFormAgreements !== 'undefined') {
            clearInterval(intervalAgreements);
            vm.formAgreements = new AFormAgreements({
              checkboxCallback: function (checked) {
                //vm.obj.form.checkbox.checked = checked;
                vm.formReadyCheck();
              },
            });
          }
        }, 10);
      } else {
        vm.formAgreements.initActions();
      }
    },
    actions: function () {
      let vm = this;

      vm.initFormAgreements();

      document.addEventListener('click', function (e) {
        let t = e.target;
        let bField = t.closest('.form__field');
        /**
         * Фокус инпута при клике на плейсхолдер
         */
        if (t.classList && t.classList.contains('place_holder')) {
          let dAttr = t.getAttribute('data-field');
          if (dAttr) {
            bField.querySelector('[name="' + dAttr + '"]').focus();
          } else {
            bField.querySelector('input').focus();
          }
        }
      });
    },
    phoneActionEdit: function (e) {
      let vm = this;
      e.preventDefault();

      vm.obj.phone.codeConfirm.classList.remove('-wait');
      vm.$parent.title = vm.$parent.msg('A_AOS_INITIAL_DATA_TITLE');
      vm.obj.phone.codeConfirm.style.display = 'none';
      vm.obj.phone.confirm.style.display = '';
      vm.obj.birthday.parentNode.style.display = '';
      vm.obj.phone.phone.classList.remove('-disabled');
      vm.obj.form.phoneAction.style.display = 'none';
      vm.$refs.phoneField.classList.add('__success');
      //vm.obj.form.checkbox.checked = false;

      vm.formReadyCheck();

      if (!BX.type.isNil(vm.fieldSMS)) {
        vm.fieldSMS.destroy();
        vm.fieldSMS = null;
      }
      setTimeout(function () {
        vm.obj.phone.codeConfirmContainer.innerHTML = '';
      }, 1000);
      vm.visiblePhoneTip('phone-send');
    },
    acceptCookies: function () {
      if (typeof aCookiePopup !== 'undefined') {
        var bCookie = document.querySelector('.cookie_accept');
        if (bCookie) {
          bCookie.querySelector('.__accept').click();
        }
      }
    },
    getPopupId: function (name) {
      let vm = this;
      if (!vm.popupId[name]) {
        vm.popupId[name] = 'popup-' + Math.random().toString(36).substring(2, 9);
      }
      return vm.popupId[name];
    },
    replaceText: function (value, search, replacement) {
      return value ? value.replace(search, replacement) : '';
    },
    initObjects: function () {
      let vm = this;
      vm.obj.aos = document.querySelector('.aos');
      vm.obj.birthday = document.querySelector('[name="birthday"]');
      vm.obj.form.phoneAction = vm.obj.aos.querySelector('.phone-action');
      //vm.obj.form.checkbox = vm.obj.aos.querySelector('[name="check"]');
      vm.obj.form.btn = vm.obj.aos.querySelector('.button-2024');
      vm.obj.phone.phone = vm.obj.aos.querySelector('[name="phone"]');
      vm.obj.phone.confirm = vm.obj.aos.querySelector('.phone-confirm');
      vm.obj.phone.codeConfirm = vm.obj.aos.querySelector('.phone-code-confirm');
      vm.obj.phone.codeConfirmContainer = vm.obj.aos.querySelector(
        '.phone-code-confirm-sms',
      );
      if (window.localStorage.aos_by_form_phone) {
        vm.obj.phone.phone.value = window.localStorage.aos_by_form_phone;
        localStorage.removeItem('aos_by_form_phone');
        //vm.obj.form.checkbox.checked = true;
        vm.obj.form.btn.removeAttribute('disabled');
        vm.obj.form.btn.click();
      }
    },
    init: function () {
      let vm = this;
      vm.maskedPhone();
      vm.maskedBirthday();
      vm.actions();
      vm.initObjects();
      vm.hideMobileIdSopd();
    },
  },
  mounted: function () {
    let vm = this;
    // До init(): он может сразу отправить форму с номером из localStorage
    vm.initYandexCaptcha();
    vm.init();
    vm.$parent.removeMessageError();
    vm.$parent.scrollToElement('._aos', 0);
  },
  beforeDestroy: function () {
    this.yandexCaptcha?.destroy();
  },
  filters: {
    rawHTML: function (value) {
      return value;
    },
  },
  template: `
          <div ref="initialData" class="aos__initial-data">
          <div class="ocf__section ocf__section-visible">
            <div class="ocf__block row__columns">
              <form class="form form-cmp" novalidate @submit.prevent="formSend" action="/" autocomplete="off"
                    onsubmit="return false;" data-theme="white_blue">
                <div ref="phoneField" class="form__field">
                  <div class="phone__block">
                    <input name="phone" type="text"
                           class="form__text-input form__text-input__phone"
                           autocomplete="off"
                           inputmode="numeric"
                           required/>
                    <span class="place_holder" data-field="phone">
                      {{ $parent.msg('A_AOS_INITIAL_DATA_FIELD_PHONE') }}
                      <span>*</span>
                    </span>
                    <div class="form__error-tip"><span>&nbsp;</span></div>
                    <div class="phone-action">
                      <a href="#" v-on:click="phoneActionEdit" class="phone-action__edit i i-edit"></a>
                    </div>
                    <div class="form__tip__phone">
                      <div class="form__tip__phone-error">
                        <div class="message__error message__noicon"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form__field">
                  <input name="birthday" type="text"
                         data-tip-empty="A_FORM_TIP_ERROR_EMPTY_BIRTHDAY"
                         data-tip-incorrect="A_FORM_TIP_ERROR_INCORRECT_BIRTHDAY"
                         class="form__text-input form__text-input__birthday"
                         autocomplete="off"
                         inputmode="numeric"
                         required/>
                  <span class="place_holder" data-field="birthday">
                      {{ $parent.msg('A_AOS_INITIAL_DATA_FIELD_BIRTHDAY') }}
                    <span>*</span>
                    </span>
                  <div class="form__error-tip"><span>&nbsp;</span></div>
                </div>
                <div class="phone-confirm">
                  <label class="l_toggle form__chbox">
                    <input
                        id="chb-first-step"
                        name="use_mobile_id"
                        type="checkbox"
                        v-on:click="checkboxEventClick"
                        class="form__chbox-input"
                    >
                    <span/>
                    <p v-html="$parent.msg('A_AOS_INITIAL_DATA_MOBILE_ID')"/>
                  </label>
                  <div ref="yandexCaptcha" class="aos__captcha"></div>
                  <div class="form-cmp__buttons __left">
                    <button type="submit" class="button-2024 -full" disabled>
                      {{ $parent.msg('A_AOS_INITIAL_DATA_BUTTON_NEXT') }}
                    </button>
                  </div>
                  <div class="form__sopd" v-if="this.$parent.content.initialData.checkbox"
                       :data-id="getPopupId('main-agreement')"
                       v-html="replaceText(this.$parent.content.initialData.checkbox, '#SOPD#', '#' + getPopupId('main-agreement') + '-content')"/>
                </div>
                <div class="phone-code-confirm aos-hidden">
                  <div class="form__tip__phone-code-send">{{ $parent.msg('A_AOS_INITIAL_DATA_TIP_PHONE_CODE_SEND') }}
                  </div>
                  <div class="form__tip__phone-code-wait"
                       v-html="$parent.msg('A_AOS_INITIAL_DATA_TIP_PHONE_CODE_WAIT')"/>
                  <div class="phone-code-confirm-sms"/>
                </div>
                <div class="form_cmp-hidden">
                  <component
                      v-if="this.$parent.content.initialData.sopd"
                      v-bind:is="'aos__popup'"
                      :id="getPopupId('main-agreement')"
                      :data="this.$parent.content.initialData.sopd"
                  ></component>
                </div>
              </form>
            </div>
          </div>
          </div>
        `,
});
